// extracted by mini-css-extract-plugin
var _1 = "EmailRecipientsCollapsed-modulecontainer__RgUTf";
var _2 = "EmailRecipientsCollapsed-moduledisabled__d1YiQ";
var _3 = "EmailRecipientsCollapsed-moduletagContainer__BvMrE";
export { _1 as "container", _2 as "disabled", _3 as "tagContainer" }
